import { h } from "preact";
import TicketInfo from "./TicketInfo";
import CheckboxField from "../../components/fields/CheckboxField";
import { Field } from "redux-form";
import { css } from "emotion";

const TicketsQuestions = ({
  tickets,
  ticketTypes,
  additionalQuestions,
  ticketsAdditionalQuestions,
  formName,
  buyerData,
  changeFieldValue,
  sameAsBuyerChecks,
  hideTitles
}) => {
  if (!tickets || !tickets.length) {
    return;
  }

  let ticketsRequireEmail = false;
  if (ticketsAdditionalQuestions) {
    const emailQuestions = additionalQuestions.filter(
      question => question.type === "email" && !question.perOrder
    );
    if (emailQuestions && emailQuestions.length) {
      ticketsRequireEmail = true;
    }
  }
  const ticketTypeCounts = {};
  tickets = tickets.map(t => {
    if (!ticketTypeCounts[t.ticketTypeName]) {
      ticketTypeCounts[t.ticketTypeName] = 0;
    }
    ticketTypeCounts[t.ticketTypeName]++;
    t.label = `Ticket ${ticketTypeCounts[t.ticketTypeName]}. ${
      t.ticketTypeName
    }`;
    // add ticketOrder to sort selected ticket
    let ticketOrder = -1;
    ticketTypes.some((type, i) => {
      if (type._id === t.ticketTypeId) {
        ticketOrder = i;
        return true;
      }
    });
    t.ticketOrder = ticketOrder;
    return t;
  });
  // sort selected ticket by ticket order from ticketTypes
  tickets.sort((a, b) => a.ticketOrder - b.ticketOrder);

  const getTicketQuestions = (ticketTypeId, additionalQuestions) => {
    return additionalQuestions.filter(question => {
      if (question.perOrder) {
        return false;
      }
      if (
        question.appliesTo &&
        question.appliesTo.length &&
        question.appliesTo.indexOf(ticketTypeId) === -1
      ) {
        return false;
      }
      return question;
    });
  };
  const ticketWithQuestions = tickets
    .map(ticket => {
      return {
        ticket: ticket,
        questions: getTicketQuestions(ticket.ticketTypeId, additionalQuestions)
      };
    })
    .filter(({ questions }) => questions.length);

  const ticketsQ = ticketWithQuestions.map(ticketQ => (
    <TicketInfo
      ticket={ticketQ.ticket}
      questions={ticketQ.questions}
      ticketsAdditionalQuestions={ticketsAdditionalQuestions}
      formName={formName}
      buyerData={buyerData}
      changeFieldValue={changeFieldValue}
      sameAsBuyerChecks={sameAsBuyerChecks}
      hideTitles={hideTitles}
    />
  ));

  if (!ticketsQ.length) {
    return;
  }

  return (
    <div style={{ borderBottom: "1px solid #dedede" }}>
      {!hideTitles ? <h3 class="sub-header">Ticket Information</h3> : null}
      {ticketsQ}
      {ticketsRequireEmail ? (
        <Field
          label="Email tickets to each attendee"
          name="order.emailAttendees"
          component={CheckboxField}
        />
      ) : null}
    </div>
  );
};

export default TicketsQuestions;



// WEBPACK FOOTER //
// ./routes/details/TicketsQuestions.js